import { AxiosResponse } from 'axios';

import { DEFAULT_QUERY_LIMIT } from '@cvt/helpers/query';
import { request } from '@cvt/clients/baseClient';
import { camelizeObject } from '@cvt/helpers/object';


const apiBaseUrl = import.meta.env.VITE__CVT_API_URL;

const getTags = (params: Stories.GetListParams): Promise<AxiosResponse<CVT.Query.PaginatedResults<Stories.Tag>>> => {
  return request({
    options: {
      url: `${apiBaseUrl}/tags/`,
      method: 'GET',
      params: {
        search: params.search,
        limit: params.limit || DEFAULT_QUERY_LIMIT,
        offset: params.offset,
      },
    },
  }).then((data: AxiosResponse<CVT.Query.PaginatedResults<Stories.Tag>>) => ({
    ...data,
    data: {
      ...data.data,
      results: data.data.results.map(camelizeObject<Stories.Tag>),
    },
  }));
};

export const tagClient = {
  getTags,
};
